import { useState ,useEffect} from "react";

import AcceptingModule from "./AcceptingModule";

const AcceptedManuscript = ({ modal, setModal,clientData,curationData,manuscriptStatus ,freezeStatus,addComment }) => {
  const [nonSimilarData, setNonSimilarData] = useState([]);

  useEffect(() => {
    if (curationData && curationData.listOfNonSimilarData) {
      setNonSimilarData(curationData.listOfNonSimilarData);
    }
  }, [curationData]);

  return (
    <div className="col-md-6">
      <div className="d-flex justify-content-between mb-3">
      <h5 className="card-title py-2">Similar Accepted Manuscripts</h5>
    </div>
  <div className="overflow-auto border p-3" style={{ maxHeight: "70vh" }}>
    
    
    {nonSimilarData && nonSimilarData.length > 0 ? (
      nonSimilarData.map((data, index) => (
        (data["llmTitleScoreFlagStatus"] === false && data["authorStatusFlagStatus"] === false && data["dateFlagFlagStatus"] === false && data["llmAuthourScoreFlagStatus"]=== false && data["doiFlagStatus"]=== false && data["journalFlagStatus"]=== false)?(
        <div key={index} className="border rounded p-2 mb-2" style={{ backgroundColor:data.curationStatus==="approved" ? "lightgrey" : "transparent"}}>
          <AcceptingModule modal={modal} setModal={setModal} clientData={clientData} curationData={data} manuscriptStatus={manuscriptStatus} freezeStatus={freezeStatus} addComment={addComment}/>
        </div>
        ):
        (<></>)
        
      ))
    ) : (
      <p className="text-muted">No non-similar manuscripts available.</p>
    )}
  </div>
</div>

  );
};

export default AcceptedManuscript;
